/* ROHBODY theme scripts — lightweight, no dependencies */
(() => {
  'use strict';
  const $ = (sel, ctx = document) => ctx.querySelector(sel);
  const $$ = (sel, ctx = document) => Array.from(ctx.querySelectorAll(sel));
  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* ---------------- Money ---------------- */
  function formatMoney(cents, format) {
    const fmt = format || '${{amount}}';
    const value = (Number(cents) || 0) / 100;
    const withDelims = (n, dec, thou, sep) => {
      const parts = n.toFixed(dec).split('.');
      parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, thou);
      return parts.join(sep);
    };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, key) => {
      switch (key) {
        case 'amount_no_decimals': return withDelims(value, 0, ',', '.');
        case 'amount_with_comma_separator': return withDelims(value, 2, '.', ',');
        case 'amount_no_decimals_with_comma_separator': return withDelims(value, 0, '.', ',');
        case 'amount_with_apostrophe_separator': return withDelims(value, 2, "'", '.');
        default: return withDelims(value, 2, ',', '.');
      }
    });
  }
  const escapeHtml = (str) => String(str ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------------- Drawers ---------------- */
  let lastFocus = null;
  function openDrawer(id) {
    const drawer = document.getElementById(id);
    if (!drawer) return false;
    lastFocus = document.activeElement;
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('rb-lock');
    $$(`[aria-controls="${id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'true'));
    const focusable = $('.rb-drawer__panel button, .rb-drawer__panel a', drawer);
    setTimeout(() => focusable && focusable.focus({ preventScroll: true }), 50);
    if (drawer.hasAttribute('data-rb-cart')) Cart.refresh();
    return true;
  }
  function closeDrawer(drawer) {
    if (!drawer) return;
    drawer.classList.remove('is-open');
    drawer.setAttribute('aria-hidden', 'true');
    $$(`[aria-controls="${drawer.id}"]`).forEach((b) => b.setAttribute('aria-expanded', 'false'));
    if (!$('.rb-drawer.is-open')) document.documentElement.classList.remove('rb-lock');
    if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
  }
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-rb-open]');
    if (opener) {
      if (openDrawer(opener.getAttribute('data-rb-open'))) e.preventDefault();
      return;
    }
    const closer = e.target.closest('[data-rb-close]');
    if (closer) closeDrawer(closer.closest('.rb-drawer'));
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = $$('.rb-drawer.is-open').pop();
    if (open) closeDrawer(open);
  });
  // Keep focus inside an open drawer
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Tab') return;
    const drawer = $$('.rb-drawer.is-open').pop();
    if (!drawer) return;
    const items = $$('a[href], button:not([disabled]), input:not([type="hidden"]), select, textarea', $('.rb-drawer__panel', drawer)).filter((el) => el.offsetParent !== null);
    if (!items.length) return;
    const first = items[0], last = items[items.length - 1];
    if (e.shiftKey && document.activeElement === first) { last.focus(); e.preventDefault(); }
    else if (!e.shiftKey && document.activeElement === last) { first.focus(); e.preventDefault(); }
  });

  /* ---------------- Cart ---------------- */
  const Cart = {
    el: null,
    get drawer() { return this.el || (this.el = $('[data-rb-cart]')); },
    get format() { return (this.drawer && this.drawer.dataset.moneyFormat) || '${{amount}}'; },
    async request(url, body) {
      const opts = body ? { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify(body) } : { headers: { Accept: 'application/json' } };
      const res = await fetch(root + url, opts);
      const data = await res.json().catch(() => ({}));
      if (!res.ok) throw new Error(data.description || data.message || 'Something went wrong. Please try again.');
      return data;
    },
    async refresh() {
      try { this.render(await this.request('cart.js')); } catch (err) { console.warn(err); }
    },
    async add(items) {
      await this.request('cart/add.js', { items });
      const cart = await this.request('cart.js');
      this.render(cart);
      if (this.drawer) openDrawer(this.drawer.id);
      else window.location.href = root + 'cart';
      return cart;
    },
    async change(key, quantity) {
      const cart = await this.request('cart/change.js', { id: key, quantity });
      this.render(cart);
    },
    render(cart) {
      $$('[data-rb-cart-count]').forEach((n) => { n.textContent = cart.item_count; n.dataset.count = cart.item_count; });
      const d = this.drawer;
      if (!d) return;
      const list = $('[data-rb-cart-items]', d);
      const empty = $('[data-rb-cart-empty]', d);
      const foot = $('[data-rb-cart-foot]', d);
      const heading = $('[data-rb-cart-heading-count]', d);
      if (heading) heading.textContent = `(${cart.item_count})`;
      const sub = $('[data-rb-cart-subtotal]', d);
      if (sub) sub.textContent = formatMoney(cart.total_price, this.format);
      empty.classList.toggle('rb-hidden', cart.item_count > 0);
      foot.classList.toggle('rb-hidden', cart.item_count === 0);
      list.innerHTML = cart.items.map((item) => {
        const img = item.image ? `${item.image}${item.image.includes('?') ? '&' : '?'}width=200` : '';
        const variant = item.variant_title && !item.product_has_only_default_variant ? `<p class="rb-cart-item__variant">${escapeHtml(item.variant_title)}</p>` : '';
        const compare = item.original_line_price > item.final_line_price ? `<s class="rb-price__compare">${formatMoney(item.original_line_price, this.format)}</s>` : '';
        return `<div class="rb-cart-item" data-key="${escapeHtml(item.key)}">
          <a class="rb-cart-item__img" href="${escapeHtml(item.url)}">${img ? `<img src="${escapeHtml(img)}" alt="${escapeHtml(item.product_title)}" width="84" height="84" loading="lazy">` : ''}</a>
          <div style="min-width:0">
            <div class="rb-cart-item__top">
              <div><a class="rb-cart-item__title" href="${escapeHtml(item.url)}">${escapeHtml(item.product_title)}</a>${variant}</div>
              <div class="rb-price" style="flex-direction:column;align-items:flex-end;gap:0">${formatMoney(item.final_line_price, this.format)}${compare}</div>
            </div>
            <div class="rb-cart-item__bottom">
              <div class="rb-qty rb-qty--sm">
                <button type="button" data-rb-line-qty="${item.quantity - 1}" aria-label="Decrease quantity of ${escapeHtml(item.product_title)}"><svg class="rb-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M5 12h14"/></svg></button>
                <input type="number" value="${item.quantity}" min="0" aria-label="Quantity of ${escapeHtml(item.product_title)}" data-rb-line-input>
                <button type="button" data-rb-line-qty="${item.quantity + 1}" aria-label="Increase quantity of ${escapeHtml(item.product_title)}"><svg class="rb-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" aria-hidden="true"><path d="M12 5v14M5 12h14"/></svg></button>
              </div>
              <button type="button" class="rb-cart-item__remove" data-rb-line-qty="0">Remove</button>
            </div>
          </div>
        </div>`;
      }).join('');
      const inCart = new Set(cart.items.map((i) => String(i.product_id)));
      const upsell = $('[data-rb-upsell]', d);
      if (upsell) {
        let visible = 0;
        $$('.rb-upsell-card', upsell).forEach((c) => { const hide = inCart.has(c.dataset.productId); c.classList.toggle('rb-hidden', hide); if (!hide) visible++; });
        upsell.classList.toggle('rb-hidden', visible === 0);
      }
    },
  };
  window.RBCart = Cart;

  document.addEventListener('click', async (e) => {
    const lineBtn = e.target.closest('[data-rb-line-qty]');
    if (lineBtn) {
      const row = lineBtn.closest('[data-key]');
      lineBtn.disabled = true;
      try { await Cart.change(row.dataset.key, Math.max(0, parseInt(lineBtn.dataset.rbLineQty, 10))); } catch (err) { alert(err.message); lineBtn.disabled = false; }
      return;
    }
    const quick = e.target.closest('[data-rb-quick-add]');
    if (quick) {
      e.preventDefault();
      const label = quick.innerHTML;
      quick.disabled = true;
      quick.setAttribute('aria-busy', 'true');
      try { await Cart.add([{ id: Number(quick.dataset.rbQuickAdd), quantity: 1 }]); }
      catch (err) { alert(err.message); }
      finally { quick.disabled = false; quick.removeAttribute('aria-busy'); quick.innerHTML = label; }
    }
  });
  document.addEventListener('change', async (e) => {
    const input = e.target.closest('[data-rb-line-input]');
    if (!input) return;
    const row = input.closest('[data-key]');
    try { await Cart.change(row.dataset.key, Math.max(0, parseInt(input.value, 10) || 0)); } catch (err) { alert(err.message); }
  });

  /* ---------------- Quantity selectors ---------------- */
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('[data-rb-qty-minus], [data-rb-qty-plus]');
    if (!btn) return;
    const input = $('input', btn.closest('[data-rb-qty]'));
    const next = (parseInt(input.value, 10) || 1) + (btn.hasAttribute('data-rb-qty-plus') ? 1 : -1);
    input.value = Math.max(1, next);
    input.dispatchEvent(new Event('change', { bubbles: true }));
  });

  /* ---------------- Sticky header ---------------- */
  let headerScrollBound = false;
  const setupHeader = () => {
    const header = $('[data-rb-header]');
    if (!header) return;
    const group = header.closest('#header-group');
    const rootStyle = document.documentElement.style;
    if (group) {
      const above = Math.max(0, header.getBoundingClientRect().top - group.getBoundingClientRect().top);
      rootStyle.setProperty('--rb-announce-h', `${above}px`);
      rootStyle.setProperty('--rb-header-offset', `${group.offsetHeight - above}px`);
    } else {
      rootStyle.setProperty('--rb-header-offset', `${header.offsetHeight}px`);
    }
  };
  setupHeader();
  window.addEventListener('resize', setupHeader, { passive: true });
  document.addEventListener('shopify:section:load', setupHeader);
  if (!headerScrollBound) {
    headerScrollBound = true;
    // Horizon scrolls inside .page-wrapper on desktop, so listen to scroll events from any container
    document.addEventListener('scroll', (e) => {
      const bar = $('.rb-header');
      if (!bar) return;
      const el = e.target === document ? document.scrollingElement : e.target;
      bar.classList.toggle('is-scrolled', (el && el.scrollTop) > 8 || window.scrollY > 8);
    }, { passive: true, capture: true });
  }

  /* ---------------- Scroll animations (storefront only, respects reduced motion) ---------------- */
  const ANIM_SELECTORS = '.rb-hero__content, .rb-section-head, .rb-feature, .rb-card, .rb-review, .rb-tabs-head, .rb-tabpanel, .rb-featured__card, .rb-featured__info, .rb-results__media, .rb-point, .rb-faq .rb-acc, .rb-contact, .rb-assure__item, .rb-split__copy, .rb-split__media, .rb-collage, .rb-ingr__item, .rb-ingr__visual, .rb-compare__copy, .rb-table, .rb-guarantee, .rb-wall__card, .rb-related-head, .rb-newsletter, .rb-quote__inner';
  const canAnimate = 'IntersectionObserver' in window && !(window.Shopify && window.Shopify.designMode) && !window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  const animObserver = canAnimate ? new IntersectionObserver((entries) => {
    entries.forEach((entry) => { if (entry.isIntersecting) { entry.target.classList.add('is-in'); animObserver.unobserve(entry.target); } });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.12 }) : null;
  function initAnimations(scope) {
    if (!animObserver) return;
    const items = $$(ANIM_SELECTORS, scope).filter((el) => !el.classList.contains('rb-anim') && !el.closest('.rb-drawer, .rb-sticky-atc'));
    const groups = new Map();
    items.forEach((el) => {
      const parent = el.parentElement;
      const i = groups.get(parent) || 0;
      groups.set(parent, i + 1);
      el.style.setProperty('--rb-i', Math.min(i, 5));
      el.classList.add('rb-anim');
      if (el.matches('.rb-ingr__visual, .rb-guarantee, .rb-tabpanel')) el.classList.add('rb-anim--zoom');
      animObserver.observe(el);
    });
  }

  function initRoot(scope) {
    initAnimations(scope);

    /* Countdown (real offers only) */
    $$('[data-rb-countdown]', scope).forEach((el) => {
      const end = new Date(el.dataset.rbCountdown).getTime();
      if (Number.isNaN(end)) { el.remove(); return; }
      const pad = (n) => String(n).padStart(2, '0');
      const tick = () => {
        const diff = end - Date.now();
        if (diff <= 0) { el.remove(); return; }
        const s = Math.floor(diff / 1000);
        $('[data-d]', el).textContent = pad(Math.floor(s / 86400));
        $('[data-h]', el).textContent = pad(Math.floor((s % 86400) / 3600));
        $('[data-m]', el).textContent = pad(Math.floor((s % 3600) / 60));
        $('[data-s]', el).textContent = pad(s % 60);
        setTimeout(tick, 1000);
      };
      tick();
    });

    /* Tabs */
    $$('[data-rb-tabs]', scope).forEach((wrap) => {
      const tabs = $$('[role="tab"]', wrap);
      const select = (tab) => {
        tabs.forEach((t) => {
          const on = t === tab;
          t.setAttribute('aria-selected', on);
          t.tabIndex = on ? 0 : -1;
          const panel = document.getElementById(t.getAttribute('aria-controls'));
          if (panel) panel.hidden = !on;
        });
      };
      tabs.forEach((tab, i) => {
        tab.addEventListener('click', () => select(tab));
        tab.addEventListener('keydown', (e) => {
          if (e.key !== 'ArrowRight' && e.key !== 'ArrowLeft') return;
          const next = tabs[(i + (e.key === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length];
          next.focus(); select(next);
        });
      });
    });

    /* Scroll dots for mobile carousels */
    $$('[data-rb-scroller]', scope).forEach((scroller) => {
      const dots = scroller.nextElementSibling && scroller.nextElementSibling.matches('[data-rb-dots]') ? scroller.nextElementSibling : null;
      if (!dots) return;
      const build = () => {
        const cards = scroller.children.length;
        const perView = Math.max(1, Math.round(scroller.clientWidth / (scroller.children[0]?.clientWidth || scroller.clientWidth)));
        const pages = Math.max(1, cards - perView + 1);
        dots.innerHTML = pages > 1 ? Array.from({ length: pages }, (_, i) => `<span${i === 0 ? ' class="is-active"' : ''}></span>`).join('') : '';
      };
      const update = () => {
        const spans = $$('span', dots);
        if (!spans.length) return;
        const max = scroller.scrollWidth - scroller.clientWidth;
        const idx = max > 0 ? Math.round((scroller.scrollLeft / max) * (spans.length - 1)) : 0;
        spans.forEach((s, i) => s.classList.toggle('is-active', i === idx));
      };
      build();
      scroller.addEventListener('scroll', () => requestAnimationFrame(update), { passive: true });
      window.addEventListener('resize', build, { passive: true });
    });

    /* Reviews wall "show more" */
    $$('[data-rb-wall-more]', scope).forEach((btn) => {
      btn.addEventListener('click', () => {
        const wall = btn.closest('.rb-container').querySelector('[data-rb-wall]');
        const step = parseInt(wall.dataset.step, 10) || 8;
        $$('.rb-wall__card.is-hidden', wall).slice(0, step).forEach((c) => c.classList.remove('is-hidden'));
        if (!$('.rb-wall__card.is-hidden', wall)) btn.remove();
      });
    });

    /* Product page */
    $$('[data-rb-product]', scope).forEach((section) => {
      const jsonEl = $('[data-rb-product-json]', section);
      const data = jsonEl ? JSON.parse(jsonEl.textContent) : { variants: [] };
      const form = $('[data-rb-product-form]', section);
      const idInput = form && $('[data-rb-variant-id]', form);
      const atc = form && $('[data-rb-atc]', form);
      const errorEl = form && $('[data-rb-form-error]', form);
      const sticky = $('[data-rb-sticky]', section);
      const stickyBtn = sticky && $('[data-rb-sticky-atc]', sticky);

      const track = $('[data-rb-gallery-track]', section);
      const slides = track ? $$('.rb-gallery__slide', track) : [];
      const thumbs = $$('[data-rb-thumb]', section);
      const dots = $$('.rb-gallery__dots span', section);
      const prev = $('[data-rb-gallery-prev]', section);
      const next = $('[data-rb-gallery-next]', section);
      const current = $('[data-rb-gallery-current]', section);
      const goTo = (i, smooth = true) => {
        if (!track || !slides[i]) return;
        track.scrollTo({ left: slides[i].offsetLeft, behavior: smooth ? 'smooth' : 'auto' });
      };
      const activeIndex = () => (track && track.clientWidth ? Math.round(track.scrollLeft / track.clientWidth) : 0);
      const syncGallery = () => {
        const i = activeIndex();
        thumbs.forEach((t, n) => t.setAttribute('aria-current', n === i));
        dots.forEach((d, n) => d.classList.toggle('is-active', n === i));
        if (prev) prev.disabled = i === 0;
        if (next) next.disabled = i >= slides.length - 1;
        if (current) current.textContent = i + 1;
        slides.forEach((s, n) => { if (n !== i) $$('video', s).forEach((v) => v.pause()); });
      };
      if (track) {
        track.addEventListener('scroll', () => requestAnimationFrame(syncGallery), { passive: true });
        track.addEventListener('keydown', (e) => {
          if (e.key === 'ArrowRight') { goTo(Math.min(slides.length - 1, activeIndex() + 1)); e.preventDefault(); }
          if (e.key === 'ArrowLeft') { goTo(Math.max(0, activeIndex() - 1)); e.preventDefault(); }
        });
      }
      thumbs.forEach((t) => t.addEventListener('click', () => goTo(Number(t.dataset.rbThumb))));
      prev && prev.addEventListener('click', () => goTo(Math.max(0, activeIndex() - 1)));
      next && next.addEventListener('click', () => goTo(Math.min(slides.length - 1, activeIndex() + 1)));

      const optionInputs = $$('[data-rb-option]', section);
      const updateVariant = () => {
        const selected = [];
        optionInputs.filter((i) => i.checked).forEach((i) => { selected[Number(i.dataset.rbOption)] = i.value; });
        $$('[data-rb-option-label]', section).forEach((l) => { l.textContent = selected[Number(l.dataset.rbOptionLabel)] || ''; });
        const variant = data.variants.find((v) => v.options.every((o, n) => o === selected[n]));
        if (!variant) {
          if (atc) { atc.disabled = true; $('[data-rb-atc-label]', atc).textContent = 'Unavailable'; }
          return;
        }
        if (idInput) idInput.value = variant.id;
        $$('[data-rb-price-current]', section).forEach((p) => { p.textContent = variant.price; });
        const cmp = $('[data-rb-price-compare]', section);
        const save = $('[data-rb-price-save]', section);
        if (cmp) { cmp.textContent = variant.compare || ''; cmp.classList.toggle('rb-hidden', !variant.compare); }
        if (save) { save.textContent = `Save ${variant.save}`; save.classList.toggle('rb-hidden', !variant.compare); }
        if (atc) {
          atc.disabled = !variant.available;
          const lbl = $('[data-rb-atc-label]', atc);
          if (!lbl.dataset.default) lbl.dataset.default = lbl.textContent;
          lbl.textContent = variant.available ? lbl.dataset.default : 'Sold out';
        }
        if (stickyBtn) stickyBtn.disabled = !variant.available;
        if (variant.media) {
          const idx = slides.findIndex((s) => s.dataset.mediaId === String(variant.media));
          if (idx > -1) goTo(idx);
        }
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url);
      };
      optionInputs.forEach((i) => i.addEventListener('change', updateVariant));

      if (form) {
        form.addEventListener('submit', async (e) => {
          e.preventDefault();
          if (!atc || atc.disabled) return;
          errorEl.textContent = '';
          atc.disabled = true;
          atc.setAttribute('aria-busy', 'true');
          try {
            const qty = Math.max(1, parseInt($('input[name="quantity"]', form).value, 10) || 1);
            await Cart.add([{ id: Number(idInput.value), quantity: qty }]);
          } catch (err) {
            errorEl.textContent = err.message;
          } finally {
            atc.disabled = false;
            atc.removeAttribute('aria-busy');
          }
        });
      }

      if (sticky && atc) {
        const footer = $('.rb-footer');
        let atcVisible = true, footerVisible = false;
        const setState = () => {
          const show = !atcVisible && !footerVisible && atc.getBoundingClientRect().top < 0;
          sticky.classList.toggle('is-visible', show);
          sticky.setAttribute('aria-hidden', String(!show));
          stickyBtn.tabIndex = show ? 0 : -1;
          document.documentElement.style.setProperty('--rb-sticky-atc-h', show ? `${sticky.offsetHeight}px` : '0px');
        };
        new IntersectionObserver(([entry]) => { atcVisible = entry.isIntersecting; setState(); }).observe(atc);
        if (footer) new IntersectionObserver(([entry]) => { footerVisible = entry.isIntersecting; setState(); }).observe(footer);
        stickyBtn.addEventListener('click', () => form.requestSubmit ? form.requestSubmit() : form.submit());
      }
    });
  }

  initRoot(document);

  // Theme editor: re-run setup when a section is edited, added or re-rendered
  document.addEventListener('shopify:section:load', (e) => {
    initRoot(e.target);
  });

  // Buttons that scroll back to the buy box
  document.addEventListener('click', (e) => {
    const link = e.target.closest('[data-rb-scroll-atc]');
    if (!link) return;
    const box = $('[data-rb-product-form]');
    if (!box) return;
    e.preventDefault();
    box.scrollIntoView({ behavior: 'smooth', block: 'start' });
    setTimeout(() => $('[data-rb-atc]', box)?.focus({ preventScroll: true }), 700);
  });

  // Keep the cart count fresh when the page is restored from the back/forward cache
  window.addEventListener('pageshow', (e) => { if (e.persisted && $('[data-rb-cart]')) Cart.refresh(); });
})();
